import '../assets/css/button.css';
import { useRef, useEffect } from 'react';

const Button = ({ calassName, text, color, onClickHandler, url }) => {
    const btnRef = useRef(null);
    useEffect(() => {
        let _text = btnRef.current.textContent;
        let spans = [];
        btnRef.current.innerHTML = "";
        for (let char of _text) {
            let span = document.createElement("span");
            span.textContent = char === ' ' ? '\u00A0' : char;
            btnRef.current.appendChild(span);
            spans.push(span);
        }

        btnRef.current.addEventListener('mouseenter', () => {
            spans.forEach((span, index) => {
                setTimeout(() => {
                    span.classList.add('hover');
                }, index * 50);
            })
        })

        btnRef.current.addEventListener('mouseleave', () => {
            spans.forEach((span, index) => {
                setTimeout(() => {
                    span.classList.remove('hover');
                }, index * 50);
            })
        })

    }, [])
    return (
        <div className={"btn-container " + (calassName !== undefined ? calassName : "")}>
            {url !== undefined && url !== null &&
                <a target="_blank" href={url} ref={btnRef} className="stylish-btn" style={{ "--clr": (color === undefined || color === null || color === '') ? "#ff7bff" : color }} onClick={onClickHandler}>{text}</a>
            }
            {(url === undefined || url === null) &&
                <button ref={btnRef} className="stylish-btn" style={{ "--clr": (color === undefined || color === null || color === '') ? "#007bff" : color }} onClick={onClickHandler}>{text}</button>
            }
        </div>
    );
}

export default Button;